import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';

import { FinanzasService } from 'app/finanzas/finanzas.service';

import { ConsultaFechaComponent } from 'app/finanzas/modals/consultaFecha/consultaFecha.component';

import { Puc } from 'app/finanzas/entidades';

@Component({
  selector: 'app-empresas',
  templateUrl: './empresas.component.html',
  styleUrls: ['./empresas.component.css']
})
export class EmpresasComponent implements OnInit {

  public empresas;

  cuenta : Puc = new Puc();

  constructor(private service: FinanzasService, private router: Router, public dialog: MatDialog) { }

  ngOnInit() {
    this.service.getEmpresas()
      .subscribe(resp => {
        this.empresas = resp;
    });
  }

  // modal seleccionar fecha 
  AbrirModal(empresa): void {
    const dialogRef = this.dialog.open(ConsultaFechaComponent, {
      width: '450px',
      data: {
        empresa: empresa,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      
    });
  }


  

}


